import React, { useEffect, useRef, useState } from "react"
import _ from "lodash"
// PR
import { DataTable } from "primereact/datatable"
import { Column } from "primereact/column"
// Components
import { field as _field } from "components/table/lib/column-field"
import SearchHeader from "components/table/search-header"
import {
  TableAutomation } from "components/table/table-automation"
import { TextEdit } from "components/table/inputs"
// Data
import attributeAssetService from "data/asset-attribute"
import validationService, {IValidationErrors} from "data/validate"
// Styles
import { AttributeTable_s } from "components/asset-management/asset-list/asset-list-styles"

const AssetAttributesTable = (props: {tableId: string, data: object[], assetid: number, readonly: boolean}) => {
  const usePrevious = (value) =>{
    const ref = useRef();
    useEffect(() => {
      ref.current = value;
    });
    return ref.current;
  }

  useEffect(() => {
    validationService.validateByParent('assetattribute', 'asset', props.assetid)
  },[props.assetid])

  const [errors, setErrors] = useState<IValidationErrors>({})
  const [searchFilter, setSearchFilter] = useState<string>("")
  const prevSearch = usePrevious(searchFilter);
  const tableRef = useRef() as React.MutableRefObject<DataTable>
  const field = _field('assetattribute')
  const readonly = props.readonly

  useEffect(() => {
    const validationSubscription = validationService.stream().subscribe((e) => {
      setErrors(e)
    })
    validationService.fetchAll('attribute')

    return function cleanup(){
      validationSubscription.unsubscribe()
    }
  }, [])

  useEffect(() => {
    if (prevSearch !== "" && searchFilter === "") _.invoke(tableRef, 'current.filter', '', 'contains');
    else if (searchFilter !== "") _.invoke(tableRef, 'current.filter', searchFilter, 'contains');
    else return
  }, [searchFilter])

  const persist = (value, field, rowData) => {
    const assetattribute = {
      assetattributeid: rowData.assetattributeid,
      assetid: rowData.assetid,
      attributeid: rowData.attributeid,
      value 
    }
    attributeAssetService.patch(assetattribute);
  }

  const rowClassName = (rowData) => {
    return {"" : rowData}
  }

  return (
    <div>
      <SearchHeader setSearchFilter={setSearchFilter} />
      <AttributeTable_s id={`${props.tableId}-scrollable-container`}>
        <DataTable
          globalFilter={searchFilter}
          id={props.tableId}
          ref={tableRef}
          value={props.data}
          paginator={true}
          rows={20}
          rowsPerPageOptions={[10, 20, 50, 100, 500]}
          scrollable={true}
          frozenWidth="45px"
          paginatorPosition="bottom"
          rowClassName={rowClassName}
          stateStorage="custom"
          customSaveState={state => localStorage.setItem("primereact-table-preferences", JSON.stringify({rows: state.rows}))}
          customRestoreState={() => JSON.parse(localStorage.getItem("primereact-table-preferences")!)}
        >
          <Column header="#" frozen={true} style={{minWidth: "45px"}}
            body={(rowData, props) => props.rowIndex + 1}
          />
          <Column style={{minWidth: "250px"}} className="p-editable-column"
            header="Code"
            {...field('code')}
          />
          <Column style={{minWidth: "250px"}} className="p-editable-column"
            header="Name"
            {...field('name')}
          />
          <Column style={{minWidth: "250px"}} className="p-editable-column"
            header="Value"
            {...field('value')}
            editor={props => TextEdit({persist, ...props, disabled: readonly})}
            />
        </DataTable>
        { props.data.length ? <TableAutomation tableId={props.tableId}/> : null }
      </AttributeTable_s>
    </div>
  )
}

export default AssetAttributesTable

